import React, { useEffect, useState } from "react";
import DTOTeamFeedback from "./DTOTeamFeedback";
import TeamFeedbackPresenter from "./TeamFeedbackPresenter";

import { useTranslation } from "react-i18next";
function TeamFeedbackController() {
  const { t } = useTranslation();

  return (
    <div>
      <DTOTeamFeedback />
      <TeamFeedbackPresenter trans={t} />
    </div>
  );
}

export default TeamFeedbackController;
